;(() => {
  const show = ($toggle, $bodyContainer) => {
    const maxHeight = $bodyContainer
      .find(".collapsible-content--body")
      .outerHeight()
    const text = $toggle.data("hide")
    $bodyContainer
      .css("max-height", maxHeight)
      .addClass("collapsible-content--body--container_expanded")
    $toggle.text(text)
  }

  const hide = ($toggle, $bodyContainer) => {
    const text = $toggle.data("show")
    $bodyContainer
      .removeAttr("style")
      .removeClass("collapsible-content--body--container_expanded")
    $toggle.text(text)
  }

  $(() => {
    $(document).on("click", ".collapsible-content--toggle", (event) => {
      event.preventDefault()
      const $toggle = $(event.currentTarget)
      const $bodyContainer = $toggle
        .parents(".collapsible-content")
        .find(".collapsible-content--body--container")

      if (
        $bodyContainer.hasClass("collapsible-content--body--container_expanded")
      ) {
        hide($toggle, $bodyContainer)
      } else {
        show($toggle, $bodyContainer)
      }
    })
  })
})()
